export class TextBlock {
  header: string;
  text: string;
  paragraphs: string[];

  constructor(
    header?: string,
    text?: string,
    paragraphs?: string[],
  ) {
    this.header = header;
    this.text = text;
    this.paragraphs = paragraphs;
  }
}
